import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import './Navbar.css';

const navLinks = [
  { label: 'О НАС', to: 'about' },
  { label: 'УСЛУГИ', to: 'services' },
  { label: 'ПРЕИМУЩЕСТВА', to: 'whyus' },
  { label: 'КОНТАКТЫ', to: 'contacts' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`navbar${scrolled ? ' navbar--scrolled' : ''}`}>
      <div className="navbar__inner">
        <Link to="hero" smooth duration={600} className="navbar__logo">
          <span className="navbar__logo-icon">⚡</span>
          ЭНЕРГОГЛАЙД
        </Link>

        <nav className={`navbar__nav${menuOpen ? ' navbar__nav--open' : ''}`}>
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              smooth
              duration={600}
              offset={-80}
              className="navbar__link"
              onClick={() => setMenuOpen(false)}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="contacts"
            smooth
            duration={600}
            offset={-80}
            className="btn btn-primary navbar__cta"
            onClick={() => setMenuOpen(false)}
          >
            Связаться
          </Link>
        </nav>

        <button
          className={`navbar__burger${menuOpen ? ' navbar__burger--open' : ''}`}
          onClick={() => setMenuOpen((v) => !v)}
          aria-label="Меню"
        >
          <span />
          <span />
          <span />
        </button>
      </div>
    </header>
  );
}
